import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

// Sentry: only initialize when a DSN is provided at build time. In dev
// VITE_SENTRY_DSN_WEB is unset, so init is a no-op and we don't ship
// errors from local development.
const dsn = import.meta.env.VITE_SENTRY_DSN_WEB as string | undefined;
if (dsn) {
  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Mask all text and block all media so PII (customer names,
        // addresses, signatures) never leaves the browser.
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    environment: import.meta.env.MODE,
  });
}

if (!window.location.hash) {
  window.location.hash = "#/";
}

createRoot(document.getElementById("root")!).render(<App />);
